package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Parcours_step(
  public val id: String,
  public val skill_id: String,
  public val code: String,
  public val kind: String,
  public val position: Long,
  public val title: String,
  public val summary: String?,
  public val planned_min: Long,
  public val level_name: String?,
  public val level_desc: String?,
  public val project_id: String?,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
